import React from 'react';
import { Card, Image, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const AgentPropertyCard = ({ property }) => {
    const getThumb = () => {
        // API'den gelen ilk fotoğrafı kullan
        if (property.photos && property.photos.length > 0) {
            return property.photos[0].imageUrl;
        }
        return '/img/default-property.jpg';
    };

    const [imageUrlLink, setImageUrlLink] = React.useState(getThumb());

    const fixImageError = (imageUrl) => {
        if (imageUrl != null) {
            let extIndex = imageUrl.lastIndexOf(".");
            let newUrl = imageUrl.substring(0, extIndex) + ".jpg";
            setImageUrlLink(newUrl);
        }
    };

    // Fiyat bilgilerini al
    const currentPrice = property.prices && property.prices.length > 0 ? property.prices[0] : null;
    const priceDaily = currentPrice?.priceDaily || 0;
    const priceMonthly = currentPrice?.price || 0;
    const priceYearly = currentPrice?.priceYearly || 0;

    // URL slug oluştur - property name'den
    const createUrlSlug = (name) => {
        return name
            .toLowerCase()
            .replace(/[^a-z0-9\s-]/g, '') // Özel karakterleri kaldır
            .replace(/\s+/g, '-') // Boşlukları tire ile değiştir
            .replace(/-+/g, '-') // Çoklu tireleri tek tire yap
            .trim();
    };

    const urlSlug = createUrlSlug(property.name);
    const lettingType = property.prices && property.prices.length > 0 ? property.prices[0].lettingType : 1;

    return (
        <Link target="_blank" to={`/${urlSlug}-${property.id}-${lettingType}`}>
            <div className="agent-property-card">
                <Card style={{ width: '100%' }}>
                    <Image
                        src={imageUrlLink}
                        wrapped
                        ui={false}
                        style={{ height: "200px" }}
                        onError={() => fixImageError(imageUrlLink)}
                    />

                    <Card.Content>
                        <Card.Header style={{ color: "#21BA45" }}>
                            {property.type || ''}
                        </Card.Header>
                        <Card.Header style={{ marginTop: 5 }}>
                            {property.name}
                        </Card.Header>
                        <Card.Meta>
                            <Icon
                                name="map marker alternate"
                                color="#21BA45"
                                style={{ marginTop: 15 }}
                            />
                            {property.location?.name || property.address}
                        </Card.Meta>
                        <Card.Description>
                            Bedroom: {property.bedrooms} Bathrooms: {property.bathrooms}
                        </Card.Description>
                    </Card.Content>

                    <div className="badges">
                        <Button
                            size="mini"
                            color="green"
                        >
                            Available Now
                        </Button>
                        <Button floated="right" size="mini" color="black">
                            {"Ref: " + property.id}
                        </Button>
                    </div>

                    <Card.Content extra>
                        <span style={{ color: "#000", fontSize: "medium" }}>
                            {property.isPriceOnRequest === true && (<>Fiyat İçin İletişime Geçin</>)}

                            {priceDaily > 0 && !property.isPriceOnRequest && (
                                <>
                                    <Icon name="euro" size={"small"} style={{ margin: 0 }} />
                                    {Intl.NumberFormat("de-DE", { style: "decimal" }).format(priceDaily)}
                                    /Day
                                </>
                            )}
                            &nbsp;&nbsp;

                            {priceMonthly > 0 && !property.isPriceOnRequest && (
                                <>
                                    <Icon name="euro" size={"small"} style={{ margin: 0 }} />
                                    {Intl.NumberFormat("de-DE", { style: "decimal" }).format(priceMonthly)}
                                    /Month
                                </>
                            )}
                            &nbsp;&nbsp;

                            {priceYearly > 0 && !property.isPriceOnRequest && (
                                <>
                                    <Icon name="euro" size={"small"} style={{ margin: 0 }} />
                                    {Intl.NumberFormat("de-DE", { style: "decimal" }).format(priceYearly)}
                                    /Year
                                </>
                            )}
                        </span>
                    </Card.Content>
                </Card>
            </div>
        </Link>
    );
};

export default AgentPropertyCard;
